import styled from "@emotion/styled";
import { IconButton, Tooltip } from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";
import { useIntercomIntegration } from "@shared/services/intercom/useIntercomIntegration";
import { useUIStore } from "@store/ui.store";
import { useBreakpoint } from "@avenue-8/sidekick-ui";

const ButtonContainer = styled.div<{ $mode: "default" | "floating" }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2.5rem;
  height: 2.5rem;
  position: ${(p) => (p.$mode === "floating" ? "fixed" : "initial")};
  z-index: 200;
  right: 0.25rem;
  bottom: 0.25rem;
`;

type Props = {
  mode?: "default" | "floating";
  hideMobile?: boolean;
};

export const HelpButton = (props: Props) => {
  const { mode = "default", hideMobile = false } = props;
  const isMobile = useBreakpoint("mobile");
  const toggleSupportDialogMode = useUIStore(
    (state) => state.toggleSupportDialogMode,
  );
  const intercom = useIntercomIntegration();

  const onClickHelp = () => {
    intercom.hide();
    toggleSupportDialogMode({ mode: "home" });
  };

  if (hideMobile && isMobile) {
    return null;
  }

  return (
    <ButtonContainer $mode={mode}>
      <Tooltip title="Help">
        <IconButton onClick={onClickHelp} id="sidekick-help-button">
          <HelpIcon />
        </IconButton>
      </Tooltip>
    </ButtonContainer>
  );
};
